/* @HEADER
 * @version 1.1.472 | 2026-10-20
 * @purpose What the diagnostic recorder is told about where the person is when it writes a record (ZVX-DEV-7882, ZVX-3825): the active workspace, the active project, the open Space and the board in focus, as ids. Read at the moment of the record; asks nobody to subscribe.
 * @sidecar recorderPlace.ts.header.md
 * @layer app | @hex _none_ | @ctx telemetry
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-7882, ZVX-DEV-7276

import { readActiveWorkspaceIdFromStorage } from '../features/auth/readActiveWorkspaceId';
import { readFocusedBoardId } from '../features/agent-bridge/public-api';
import { readOpenSpace } from '../features/telemetry/public-api.mjs';
import { getActiveProject } from '../lib/projectStore';

export type RecorderPlace = { org: string | null; project: string | null; space: string | null; board: string | null };

/**
 * Ids only, never names. A part that is not known is `null` and the recorder leaves its key out; on a screen with no board
 * open (all projects, the canvas, the wiki) the organisation and the project are what is known. The board is asked for
 * only while a Space is open, so a board that was left behind on another screen is never named.
 */
export function readRecorderPlace(): RecorderPlace {
  const space = readOpenSpace();
  return {
    org: readActiveWorkspaceIdFromStorage() ?? null,
    project: getActiveProject()?.id ?? null,
    space,
    board: space ? readFocusedBoardId() : null,
  };
}
